<template>
    <div class="container-fluid">
        <div class="page-heading mb-4"><p class="page-eyebrow">QUIZ MANAGEMENT</p><h1 class="h3 mb-1 text-gray-800">Quizzes</h1><p class="mb-0 text-muted">Create, run, and review delegate quizzes in one place.</p>
        </div>

        <QuizList></QuizList>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import QuizList from "@/components/quiz/QuizList.vue";

export default defineComponent({
    name: "QuestionPage",
    components: {
        QuizList
    }
})
</script>


<style scoped>
.page-heading{border-bottom:1px solid #e2e6ea;padding-bottom:1rem}.page-eyebrow{color:#426cc6;font-size:.72rem;font-weight:700;letter-spacing:.08em;margin:0 0 .35rem}
</style>
